import { render } from "./AsBannerSquare.vue?vue&type=template&id=7fde1118&scoped=true&ts=true"
import script from "./AsBannerSquare.vue?vue&type=script&lang=ts"
export * from "./AsBannerSquare.vue?vue&type=script&lang=ts"

import "./AsBannerSquare.vue?vue&type=style&index=0&id=7fde1118&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fde1118"]])

export default __exports__